import { useEffect, useState } from 'react';
import { useUIStore } from '@/state/store';
import { playSound } from '@/hooks/useAudio';
import { apiFetch } from '@/lib/auth';
import { saveCallSession, clearCallSession } from '@/lib/callSession';
import { IncomingCallCard } from '@/components/call/IncomingCallCard';

interface IncomingCallData {
  callId: string;
  steleName: string;
  tenantName: string;
  group: string;
  strategy: string;
  waitingMs: number;
}

export function Incoming() {
  const setView = useUIStore((s) => s.setView);
  const audioPrefs = useUIStore((s) => s.audioPrefs);
  const showHeaderChip = useUIStore((s) => s.showHeaderChip);
  const [call, setCall] = useState<IncomingCallData | null>(null);

  useEffect(() => {
    const c = (window as any).__incomingCall as IncomingCallData | undefined;
    if (c) setCall(c);
  }, []);

  function getToken() {
    const t = localStorage.getItem('bamoa_token');
    return t ? `Bearer dev:${t}` : '';
  }

  async function accept() {
    console.log('[incoming] accept clicked, callId=', call?.callId);
    playSound('accept', audioPrefs);
    if (call) {
      try {
        console.log('[incoming] POST /api/calls/' + call.callId + '/accept');
        const r = await apiFetch(`/api/calls/${call.callId}/accept`, { method: 'POST' });
        console.log('[incoming] accept response status=', r.status);
        if (r.ok) {
          const data = await r.json();
          console.log('[incoming] accept ok, rtcToken length=', (data.rtcToken ?? '').length);
          (useUIStore.getState() as any).rtcToken = data.rtcToken;
          (useUIStore.getState() as any).activeCallId = data.callId;
          (window as any).__rtcToken = data.rtcToken;
          (window as any).__activeCallId = data.callId;
          // Welle 8c-pre47 (F5-Restore): Kontext sichern, damit ein Reload den Call wiederaufnimmt.
          saveCallSession({ callId: data.callId, rtcToken: data.rtcToken, incoming: (window as any).__incomingCall ?? null });
        } else {
          const body = await r.text();
          console.warn('[incoming] accept fehlgeschlagen, body=', body);
        }
      } catch (e) {
        console.warn('[incoming] accept exception', e);
      }
    } else {
      console.warn('[incoming] kein call-Objekt verfügbar');
    }
    console.log('[incoming] setView incall');
    setView('incall');
  }

  async function decline() {
    if (call) {
      try {
        await apiFetch(`/api/calls/${call.callId}/decline`, { method: 'POST' });
      } catch (e) {
        console.warn('decline fehlgeschlagen', e);
      }
    }
    clearCallSession();
    setView('dashboard');
  }

  // Welle 12 (pre118): Companion-Remote — Annehmen/Ablehnen vom Companion ausführen.
  useEffect(() => {
    const onRemote = (e: Event) => {
      const action = (e as CustomEvent).detail?.action;
      if (action === 'accept') void accept();
      else if (action === 'decline') void decline();
    };
    window.addEventListener('bamoa:remote-cmd', onRemote);
    return () => window.removeEventListener('bamoa:remote-cmd', onRemote);
  });

  const steleName = call?.steleName ?? 'Stele';
  const tenantName = call?.tenantName ?? '';
  const groupName = call?.group ?? '';
  const strategy = call?.strategy ?? '';
  const waitingSec = call ? Math.round(call.waitingMs / 1000) : 12;

  return (
    <div className="incoming-stage view active">
      <IncomingCallCard
        steleName={steleName}
        tenantName={tenantName}
        group={groupName}
        strategy={strategy}
        waitingSec={waitingSec}
        onAccept={accept}
        onDecline={decline}
      />
    </div>
  );
}
